import { omit } from 'lodash'
import { ParsedOpeningHourWithStatus, ParsedOpeningHour } from './types'

export function stripStatus(
  parsedHours: ParsedOpeningHourWithStatus[]
): ParsedOpeningHour[] {
  return parsedHours.map(parsed => omit(parsed, 'status'))
}
